// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3oSs3","footer":"ModalCreateQualiphyProcedure_footer__3hYQh","additionData":"ModalCreateQualiphyProcedure_additionData__2pyGT"};